export default __webpack_public_path__ + "static/media/billing.c4ba7ebc.svg";